export enum CostType {
  FIX = "FIX" as any,
  FORMULA = "FORMULA" as any,
}
